// extracted by mini-css-extract-plugin
module.exports = {"card":"_2LgD3","title":"TqXBF","text":"sMgtg","image":"t1piP","type_participants":"_1gDae","type_tickets":"XxBhX","type_card":"_9bIaq","type_app":"rxH9X"};